import { Box } from '@chakra-ui/react';
import { forwardRef, useImperativeHandle, useEffect } from 'react';
import { FormBuilder } from '@/components/formBuilder';
import { useOfferStore } from '../store';

interface OfferDetailsProps {
  initialValues: any;
  detailsFormConfig: any[];
  detailsFormRef: any;
}

export const OfferDetails = forwardRef<any, OfferDetailsProps>(
  function OfferDetails(props, comRef) {
    const {
      initialValues = {},
      detailsFormConfig = [],
      detailsFormRef: formRef,
    } = props;
    const setOfferPayload = useOfferStore((state) => state.setOfferPayload);

    // Seed the store on mount so step 2 can read filled values even when the
    // user never clicked "Next" (e.g. edit flow that starts on step 2).
    useEffect(() => {
      if (initialValues && Object.keys(initialValues).length > 0) {
        setOfferPayload(initialValues);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(comRef, () => ({
      getModel: async () => {
        const formValues = formRef?.current?.values || {};
        formRef?.current?.validateForm();
        const isFormValid = formRef?.current?.isValid || false;
        const isValid = isFormValid;
        if (!isValid) {
          await formRef?.current?.submitForm();
          await new Promise((resolve) => setTimeout(resolve, 50));
          const customFieldsErrArray = Object.keys(formRef?.current?.errors);
          const invalidElements = document.querySelectorAll(
            '[aria-invalid="true"]'
          );

          if (invalidElements?.length > 0) {
            const errorElement = invalidElements[0];
            errorElement?.scrollIntoView?.({
              behavior: 'smooth',
              block: 'center',
            });
            return;
          }

          if (customFieldsErrArray?.length > 0) {
            const element = document?.getElementById?.(
              customFieldsErrArray?.[0]
            );
            element?.scrollIntoView?.({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }
        if (isValid) {
          setOfferPayload(formValues);
        }
        return {
          hasValidData: isValid,
          payload: formValues,
        };
      },
    }));

    const handleDetailsFormSubmit = (values = {}) => {
      console.log('failed_modal_values', values);
    };

    return (
      <Box ref={comRef}>
        <Box h="100%" w="100%" overflowY="auto" overflowX="hidden" p="0">
          <FormBuilder
            key={
              [
                'type_of_equity',
                'amount',
                'cliff_of_vesting',
                'cycles_after_cliff',
                'period_of_vesting',
                'strike_price',
              ].some(
                (k) =>
                  initialValues?.[k] !== null &&
                  initialValues?.[k] !== undefined
              )
                ? 'ready'
                : 'pending'
            }
            initialValues={initialValues || {}}
            config={detailsFormConfig}
            onSubmit={handleDetailsFormSubmit}
            formRef={formRef}
          />
        </Box>
      </Box>
    );
  }
);

OfferDetails.displayName = 'OfferDetails';
